import { ViewPort } from '../types/app-state';

type ErrorLogArgs = {
    message: string;
    url?: string;
    componentName?: string;
    error?: Error;
    viewport?: ViewPort,
};

export const logErrorToServer = (args: ErrorLogArgs) => {
    const { message, url, componentName, error, viewport } = args;

    fetch('/api-client/log-error', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            message,
            url,
            error: error?.toString(),
            componentName,
            viewportString: viewport && `${viewport.width}x${viewport.height}`,
        })
    });
};
